<template>
  <div>
    <h2>Leaderboard</h2>
    <b-table striped :items="results" :fields="['authority', 'total_saved']">
      <template #cell(authority)="data">
        <h4 :class="`text-left ${data.index === 0 ? 'text-success' : ''}`">
          <span class="position-number">{{ getPosition(data.index) }}.</span>
          {{ data.value }}
        </h4>
      </template>
      <template #cell(total_saved)="data">
        <div :class="data.index === 0 ? 'text-success' : ''">
          <div class="total-saved">{{ data.value | currency }}</div>
          <div style="padding: 12px 0">
            <leader-board-stat metric="# of savings" :value="data.item.number_of_savings | commas"/>
            <leader-board-stat metric="savings" :value="data.item.saved | currency"/>
            <leader-board-stat metric="back-dated" :value="data.item.retro | currency"/>
            <leader-board-stat metric="fines" :value="data.item.fines | currency"/>
          </div>
        </div>
      </template>
      <template #cell(number_of_savings)="data">{{ data.value | commas }}</template>
    </b-table>
  </div>
</template>

<script>
import LeaderBoardStat from './LeaderBoardStat.vue'

export default {
  components: { LeaderBoardStat },
  props: ['results'],
  methods: {
    getPosition(index) {
      const position = index + 1;
      return position < 10 ? `0${position}` : position;
    }
  },
};
</script>

<style scoped>
.position-number {
  opacity: 0.3;
  display: inline-block;
  width: 35px;
}

.total-saved {
  font-weight: bold;
  font-size: 18pt;
  text-align: right;
  margin-top: 0;
  padding-top: 0;
}
</style>
